import React, { PropsWithChildren } from 'react';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Divider from '@material-ui/core/Divider';
import { makeStyles, createStyles } from '@material-ui/core/styles';

const useStyles = makeStyles(() =>
  createStyles({
    iframeStyle: {
      width: '100%',
      border: 'none',
    },
  })
);

interface GuestsDialogProps {
  open: boolean;
  onClose(): void;
}

function GuestsDialog({ open, onClose }: PropsWithChildren<GuestsDialogProps>) {
  const classes = useStyles();
  const url =
    process.env.REACT_APP_TOKEN_ENDPOINT + '/api/room-guests?m=' + new URLSearchParams(window.location.search).get('m');

  return (
    <Dialog open={open} onClose={onClose} fullWidth={true} maxWidth="xs">
      <DialogTitle>Vendégek</DialogTitle>
      <Divider />
      <DialogContent>
        <iframe
          className={classes.iframeStyle}
          title={'Vendégek'}
          allow={'clipboard-write;'}
          src={url}
          style={{ height: '420px' }}
        />
      </DialogContent>
      <Divider />
      <DialogActions>
        <Button onClick={onClose} color="primary" variant="contained" autoFocus>
          Bezár
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default GuestsDialog;
